"use client"

import React, { useEffect, useState } from "react";

type LiveStatusResponse = {
    isLive: boolean
}

const NavbarLiveStatus = (props: any) => {
    const [isLive, setIsLive] = useState<boolean>(props.isLive || false)

    useEffect(() => {
        const timer = setInterval(() => {
            fetch(`${window.location.origin}/api/livestream/status`)
                .then(response => response.json())
                .then((data: LiveStatusResponse) => {
                    setIsLive(data.isLive)
                }).catch(() => {})
        }, 30000);

        return () => {
            window.clearInterval(timer);
        };
    }, [isLive]);

    return (
        (isLive || props.testModus) ? <span className={`live-bar-pill ${(props.hidden && props.testModus) ? "live-par-bill-testing-mode": ""}`}>
            {(props.testModus) ? "TESTING MODE": "LIVE"}
        </span> : <></>
    );
};

export default NavbarLiveStatus